module.exports = __webpack_public_path__ + "0f87854345af37155509f7d440cafbe3.pdf";